import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

/* bootstrap */
import { ModalDirective } from 'ngx-bootstrap/modal';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

/* jquery */
declare var $: any;

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styles: [
  ]
})
export class JobsComponent implements OnInit, OnDestroy{

  @ViewChild('autoShownModal', { static: false }) autoShownModal: ModalDirective;
  isModalDanger = false;
  isLang;
  regional;
  dataRegional = [];
  dataPerRegional;
  loadingData;
  dataSection = [];

  constructor( private renderer: Renderer2,
                private elem: ElementRef,
                private apiService: ApiService,
                private globalService: GlobalService,
                private router: Router) { 
    this.globalService.isLoading.next(true);
  }

  ngOnInit(): void {
    // MultiLanguage
    this.isLang =  this.apiService.isLang();
    //added by steven (temporary solution / hardcode)
    const isEnglish = this.isLang.chooseOne === 'Choose One';
    if(isEnglish) {
      this.isLang.modalTitle = 'Beware of Employee Recruitment Fraudulent';
      this.isLang.modalContent = 'PT Prime Agri Resources Tbk does not charge any fees in the recruitment process. Avoid scams by paying close attention to email and web that are used for job vacancies. We are not responsible for fraudulent job vacancies on behalf of the PT Prime Agri Resources Tbk.';
    } else {
      this.isLang.modalTitle = 'Waspada Penipuan Rekrutmen Karyawan';
      this.isLang.modalContent = 'PT Prime Agri Resources Tbk tidak memungut biaya apapun dalam proses rekrutmen. Hindari penipuan dengan memperhatikan email dan web yang digunakan untuk lowongan pekerjaan. Kami tidak bertanggung jawab atas penipuan lowongan pekerjaan yang mengatasnamakan PT Prime Agri Resources Tbk.';
    }
    //end added by steven (temporary solution / hardcode)
    // Content
    this.apiService.getDataApi('getMenuSection/career').subscribe(response => {
      if(response.success){
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.dataSection = response.data.section;
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // jobs
    this.apiService.getDataApi('getRegionalCareer').subscribe(response => {
      response.data.forEach((i,x) => {
        this.dataRegional.push({
          'id' : i.id,
          'text' : i.title
        });
      });
      this.regional = this.dataRegional[0];
      this.apiService.getDataApi('getRegionalCareer?regional='+this.regional.id).subscribe(response => {
        this.dataPerRegional = response.data;
      });
      this.globalService.isLoading.next(false);
      setTimeout(()=>{ 
        this.showModal();
      }, 3000);
    });
    
    this.renderer.addClass(document.body, 'select-ver3');
  }

  selectRegional(event) {
    this.loadingData = true;
    this.dataRegional.forEach((i,x) => {
        if(event == i.id){
          this.regional = i;
        }
    });
    this.apiService.getDataApi('getRegionalCareer?regional='+event).subscribe(response => {
      this.dataPerRegional = response.data;
      this.loadingData = false;
    });
  }

  showModal(): void {
    this.isModalDanger = true;
  }
 
  hideModal(): void {
    this.autoShownModal.hide();
  }
 
  onHidden(): void {
    this.isModalDanger = false;
  }
  
  apply(regional, position){
     this.router.navigate(['/career/form-job'], { queryParams: { regional: regional, position: position } });
  }

  ngOnDestroy(){
    this.renderer.removeClass(document.body, 'select-ver3');
    /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open');
  }

}
